import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link,useNavigate } from "react-router-dom";
import { FaSearchPlus, FaRegImage, FaLink, FaImage, FaRegFilePdf, FaVideo } from "react-icons/fa";
import $ from "jquery";
import WOW from "wowjs";
import { GetNewsList } from "../../api/news-functions";
import { GetNewsTypeDistinctYearList } from "../../api/news-type-distinct-year-functions";
import { GetNewsGalleryList } from "../../api/news-gallery-functions";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import FsLightbox from "fslightbox-react";
import Metatag from '../../hooks/Metatag'
import globalVariables from "../../global-variables";

export default function News() {

  const navigate = useNavigate();
  const [toggler, setToggler] = useState(false);
  const [index, setIndex] = useState(0);
  const [videos, setvideosToggler] = useState(false);

  const [news, setNewsList] = useState(null);
   
  const [newstypeyear, setNewsTypeYearList] = useState([]);
  const [news_gallery_toggler, setNewsGalleryToggler] = useState(false);
  const [news_gallery, setNewsGallery] = useState([]);
  const [news_gallery_titel, setNewsGalleryTitel] = useState([]);
  
  const [gallery_key, setGalleryKey] = useState("");
  const [lightbox_video, setLightBoxVideo] = useState([]);

   // success function when the list is retrived
   const OnGetNewsSuccess = (p_response) => 
   {

     // set the list for looping
     setNewsList(p_response);
}

const OnGetNewsTypeYearSuccess = (p_response) => {
 

 // set the list for looping
 setNewsTypeYearList(p_response);

 setTimeout(() => {
     // get the current news dropdown list
     let _ddlYear = document.getElementById("ddlNewsYear");


     // bind the on change event to the dropdown list
     _ddlYear.onchange = (e) => {

         //call the function to get the news
         // make the object for getting the news list
         let _objNews = new Object();
         _objNews._news_type_id = global.variables.strNewsTypeForNews_id;
         _objNews._news_status = 1;
         _objNews._selected_year = e.target.value;

         // call the function to get the news list
         GetNewsList(_objNews, OnGetNewsSuccess,navigate);

     };

     // call the onchange event for loading the news for the first time
     // Create a new 'change' event
     var event = new Event('change');

     // Dispatch it.
     _ddlYear.dispatchEvent(event);
 }, 100);
}

   // success function when news gallery is retrived
   const OnGetNewsGallerySuccess = (p_response) => {

    //  let _arrGallery = [];

    //  let _arrGalleryTitel = [];

    //  // loop and make the array for binding the gallery
    //  for (let i = 0; i < p_response.length; i++) {
    //      _arrGallery.push(global.variables.strApiUrl + "/news-gallery-image/" + p_response[i].gallery_pic);
    //      _arrGalleryTitel.push(p_response[i].gallery_title);
    //  }
     // set the array in the constant
     setNewsGallery(p_response);

     setGalleryKey(Date.now());

     // using time out for the value to get saved in state 
     setTimeout(() => {
         // trigger the link click to display the news gallery popup
         document.getElementById("lnk_trigger_news_gallery_popup_home").click();
     }, 200);

 }

     // function to invoke photo gallery
     const InvokePhotoGallery = (e, p_news_id) => {

       e.preventDefault();

       // Make an object for getting news gallery
       let _objNewsGallery = new Object();
       _objNewsGallery.gallery_status = 1;
       _objNewsGallery.gallery_news_id = p_news_id;

       // call the function to get the news gallery
       GetNewsGalleryList(_objNewsGallery, OnGetNewsGallerySuccess,navigate);

   };

   // function to invoke video popup
   const InvokeVideoPopup = (e, p_news_video_url) => {

       e.preventDefault();

       let _arrVideos = [];
       _arrVideos.push(p_news_video_url);

       // set the path to the constant for displaying
       setLightBoxVideo(_arrVideos);

       // trigger the link click to display the popup
       document.getElementById("lnk_trigger_video_popup_home").click();

   };


 const handleSelect = (selectedIndex, e) => {
   setIndex(selectedIndex);
 };

  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");

  }, []);

  useEffect(()=>{
    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  },[news])

  // things to be done when the page is loaded
  useEffect(() => {

    //make the object for getting the news type year list
    let _objNewsTypeYear = new Object();
    //news type condition come here as general or event
    // _objNewsTypeYear._news_type_id = global.variables.strNewsTypeGeneral_id;
    // call the function to get the news type year list
    GetNewsTypeDistinctYearList(_objNewsTypeYear, OnGetNewsTypeYearSuccess,navigate)

}, []);


  return (
    <>
      <Header main_className="bg-header"></Header>
      {/* Metatag  */}
      <Metatag title='National Diseases Modelling Consortium News'
                        keywords='NDMC News, Disease Modelling News, NDMC IIT-B News' 
                        description='News about National Diseases Modelling Consortium'
                        />

      <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-news.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
        <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
        <div className="masthead d-flex align-items-center w-100">
          <Container className="px-4 px-md-5 pb-xl-5 py-4">
            <div className="d-flex align-items-end">
              <div className="d-inline-block m-0 d-flex align-items-center">
                <h1 className="mb-0 fw-bold text-white text-uppercase">News -</h1>
                <div className="ms-md-3 ms-2">
                  {
                      newstypeyear.length > 0 ?
                          <select aria-label="Default select example" className="shadow-none form-select" id="ddlNewsYear">
                              {
                                  newstypeyear.map((val) => {
                                      return (

                                          <option value={val.news_year} key={val.news_year}>{val.news_year}</option>
                                      )
                                  })
                              }
                          </select>
                          :
                          <select aria-label="Default select example" className="shadow-none form-select" id="ddlNewsYear">
                            <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                          </select>
                    }
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Container>

      <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
        {
          news != null ? 
            news.length > 0 ?
              news.map((val_news)=>{
                return(
                  <div className="border p-md-4 p-2 rounded-3 mb-4">
                    <Row className="wow fadeInUp">
                      <Col className="order-lg-1 order-2">
                        <h5 className="mb-2 text-dark"></h5>
                        <h4 className="red-text wow fadeInUp">
                          {val_news.news_headline}
                        </h4>
                        
                        <p className="wow fadeInUp">{val_news.news_date}
                        
                          {val_news.news_caption != null && val_news.news_caption != "" && val_news.news_caption != "null"?<><br/> Venue: {val_news.news_caption}</> : null}
                          {val_news.news_sourse != null && val_news.news_sourse != "" && val_news.news_sourse != "null"?<><br/> Source: {val_news.news_sourse}</>  : null} <br/>
                        </p>

                        {
                          val_news.news_details != '' ?
                          <p dangerouslySetInnerHTML={{ __html : val_news.news_details}}></p>
                          :
                          null
                        }
                        
                      </Col>
                        
                          <Col xl={3} lg={4} className="order-lg-2 order-1">
                          
                          {
                            (val_news.news_images != '' && val_news.news_images != null) || parseInt(val_news.news_gallery_count) > 0 ?
                            <Row>
                              <Col lg={12} md={6}>
                                <div className="text-center">
                                  {
                                    val_news.news_gallery_count > 0 ?
                                      <Link onClick={event => InvokePhotoGallery(event, val_news.news_id)}>
                                        <div className="rounded-3 border position-relative overflow-hidden d-inline-block">
                                          {
                                            val_news.news_images != '' && val_news.news_images != null ?
                                              <>
                                                <img src={global.variables.strApiUrl + "/news-main-image" + "/" + val_news.news_images} alt={val_news.news_headline} title={val_news.news_headline} className="img-fluid rounded-3 mb-md-0  wow fadeIn" />
                                                <i className="fa-search-plus bg-white px-2 py-1"><FaSearchPlus className="" /></i>
                                              </>
                                            
                                            :
                                            null
                                          }
                                        </div>
                                      </Link>
                                    :
                                    <div className="rounded-3 border position-relative overflow-hidden d-inline-block">
                                        {
                                          val_news.news_images != '' && val_news.news_images != null ?
                                            val_news.news_gallery_count > 0 ?
                                            <>
                                              <img src={global.variables.strApiUrl + "/news-main-image" + "/" + val_news.news_images} alt={val_news.news_headline} title={val_news.news_headline} className="img-fluid rounded-3 mb-md-0  wow fadeIn" />
                                              <i className="fa-search-plus bg-white px-2 py-1"><FaSearchPlus className="" /></i>
                                            </>
                                            :
                                            <img src={global.variables.strApiUrl + "/news-main-image" + "/" + val_news.news_images} alt={val_news.news_headline} title={val_news.news_headline} className="img-fluid rounded-3 mb-md-0  wow fadeIn" />
                                          :
                                          null
                                        }
                                      </div>

                                  }
                                  {
                                    parseInt(val_news.news_gallery_count) > 0 ?
                                      <Link onClick={event => InvokePhotoGallery(event, val_news.news_id)} data-toggle="tooltip" className="btn btn-slide rounded-pill px-4 py-2 d-inline-flex align-items-center text-white mt-md-3 mt-2" title="">
                                        <FaRegImage className="me-2 icon-20" />Photo Gallery
                                      </Link>
                                    :
                                      null

                                  }
                                  
                                </div>
                                <div className="text-center">
                                

                                </div>
                              </Col>
                            </Row>
                            :
                            null
                          }
                          {
                           ( val_news.news_link != '' && val_news.news_link != null)
                            || (val_news.news_document != '' && val_news.news_document != null)
                           || (val_news.news_video_link != '' && val_news.news_video_link != null)
                            ?
                            <Row className="mt-3 mb-3">
                              <Col>
                              <div className="mt-2 text-center">
                                    {/* {/ link /} */}
                                    {
                                        val_news.news_link != null && val_news.news_link != "null" && val_news.news_link != "" ?
                                        <Link style={{marginRight: '8px'}} to={val_news.news_link} target="_blank" className="btn btn-slide btn-warning rounded-pill Faicon px-3 py-1 ms-auto mt-auto wow fadeInUp"><FaLink /></Link>
                                        :
                                        null
                                    }
                                    
                                    {/* {/ Document /} */}
                                    {
                                        val_news.news_document != null && val_news.news_document != "null" && val_news.news_document != "" ?
                                            <Link style={{marginRight: '8px'}} to={global.variables.strApiUrl + "/news-documents/" + val_news.news_document} target="_blank" className="btn btn-slide btn-warning rounded-pill Faicon px-3 py-1 ms-auto mt-auto wow fadeInUp"><FaRegFilePdf /></Link>
                                            :
                                            null
                                    }

                                    {/* {/ Video /} */}
                                    {
                                          val_news.news_video_link != null && val_news.news_video_link != "null" && val_news.news_video_link != "" ?
                                              <a style={{marginRight: '8px'}} className="btn btn-slide btn-warning rounded-pill Faicon px-3 py-1 ms-auto mt-auto wow fadeInUp" onClick={event => InvokeVideoPopup(event, val_news.news_video_link)}><FaVideo /></a>
                                              :
                                              null
                                      }
                                                      
                                </div>
                              </Col>
                            </Row>
                            : 
                            null
                          }
                            
                          </Col>
                        
                    </Row>
                  </div>

                )
              })
                :
                 
                    <Row>
                      <span className="text-center"><b>No records found</b></span>
                    </Row>
                  
              :
              
                <Row>
                  <span className="text-center">Loading...</span>
                </Row>
              
        }
      </Container >
      
      {/* {/ Video popup /}
        {/ this link will open the video popup which will be hidden because the button from the grid is causing issue /} */}
        <a onClick={(e) => {
            e.preventDefault();
            setvideosToggler(!videos);
        }}
            className="d-none"
            id="lnk_trigger_video_popup_home">

            </a>

        <FsLightbox
            toggler={videos}
            sources={lightbox_video}
            
        />


        {/* {/ News Gallery popup /}
      {/ this link will open the news gallery popup which will be hidden because the button from the grid is causing issue /} */}
      <a onClick={(e) => {
          e.preventDefault();
          setNewsGalleryToggler(!news_gallery_toggler);
      }}
          className="d-none"
          id="lnk_trigger_news_gallery_popup_home"></a>

<FsLightbox
        toggler={news_gallery_toggler}
        sources={news_gallery?.map((item) => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              key={item.gallery_id}
              className="fsDiv"
            >
              <img
                className="img-fluid"
                src={`${globalVariables.variables.strApiUrl}/news-gallery-image/${item.gallery_pic}`}
                alt={item.gallery_title}
                style={{ objectFit: "contain" }}
              />
              <p
                style={{
                  textAlign: "center",
                  color: "white",
                  fontSize: "16px",
                }}
              >
                {item.gallery_title}
              </p>
            </div>
          );
        })}
        key={gallery_key}
      />
      {/* Breadcrumb */}
      <Container  fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
        <Breadcrumb>
          <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>News</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      {/* Breadcrumb */}
    </>
  );
}